<app-header></app-header>
<app-alerts></app-alerts>
<app-modal-popup></app-modal-popup>
<router-outlet></router-outlet>
<app-footer></app-footer>